module.exports = __webpack_public_path__ + "static/media/discover.ad34efa6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/discover.svg
// module id = 298
// module chunks = 0